import {
  Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit,
  HostListener, ChangeDetectorRef, Input
} from '@angular/core';

import { AngularResizeEventModule, ResizedEvent } from 'angular-resize-event';
import { ToFriend } from '@app/shared/models';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-select-third-party-wallet-detail',
    imports: [
        CommonModule,
        TranslateModule,
        AngularResizeEventModule
    ],
    templateUrl: './select-third-party-wallet-detail.component.html',
    styleUrls: ['./select-third-party-wallet-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectThirdPartyWalletDetailComponent implements OnInit, AfterViewInit {

  @Input() toFriend: ToFriend;

  // style
  isMobileSize: boolean;
  walletClass: string;

  @ViewChild('wallets') walletsView: ElementRef;
  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  /*******************************************************************
   Life Cycle
  *******************************************************************/

  ngOnInit(): void {
    this.onResize();
  }

  ngAfterViewInit(): void {
    if (this.walletsView) {
      this.walletClass = this.getClass(this.walletsView.nativeElement.offsetWidth);
      this.cdr.detectChanges();
    }
  }

  /*******************************************************************
   General
  *******************************************************************/

  onResized(event: ResizedEvent) {
    this.walletClass = this.getClass(event.newRect.width);

  }

  getClass(width: number): string {
    if (width < 510) {
      return 'wallet-xs';

    } else if (width > 509 && width < 728) {
      return 'wallet-sm';

    } else if (width > 727 && width < 1027) {
      return ('wallet-md');

    } else if (width > 1026 && width < 1500) {
      return 'wallet-lg';

    } else if (width > 1499) {
      return 'wallet-lg';

    }
  }

  @HostListener('window:resize', ['$event'])
  onResize($event?) {
    if (window.innerWidth < 993) {
      this.isMobileSize = true;
    } else {
      this.isMobileSize = false;
    }

  }

}
